import BigNumber from 'bignumber.js';
import { toFormatUnit } from '@fe/utils/number';
import { DEFAULT_VAL } from '@/utils/constants';

// 去除小数结尾的0
export function removeFloatZero(value: number | string) {
  return Number(value)
    .toString()
    .replace(/(\.[0-9]*[1-9])0+$/, '$1');
}

// usdt资产数值展示
export const cellDataFormatter = (
  value: number | string,
  showUsdt = false,
  showSymbol = false
) => {
  // 默认展示 --
  if (value === DEFAULT_VAL) {
    return value;
  }
  if (!+value) {
    return '0.00';
  }
  const lt0Symbol = showSymbol ? '+' : '';
  // 大于0, 小于 0.0001 - 展示 0.0001
  if (BigNumber(value).abs().lt(0.0001) && BigNumber(value).abs().gt(0)) {
    return `≈ ${+value < 0 ? '-' : lt0Symbol}${showUsdt ? '$' : ''}0.0001`;
  }
  return `${+value < 0 ? '-' : lt0Symbol}${showUsdt ? '$' : ''}${toFormatUnit(removeFloatZero(Number(BigNumber(value).abs())), 4)}`;
};

// 盈亏比例展示
export const rateText = (value: number | string) => {
  let str = '';
  if (+value === 0) {
    str = '0.00%';
  } else if (+value > 0) {
    str = +value < 0.01 ? '+0.01%' : `+${BigNumber(value).toFixed(2)}%`;
  } else if (+value < 0) {
    str = +value > -0.01 ? '-0.01%' : `${BigNumber(value).toFixed(2)}%`;
  }
  return str;
};

export const sliceTableData = (
  list: any[],
  currentPage: number,
  pageSize: number
) => {
  return list.slice((currentPage - 1) * pageSize, currentPage * pageSize);
};
